/**
 * Project panel
 *
 * Created by stefensuhat on 08/08/18 2.48 PM
 */

import appModel, { alert } from './appModel';
import snackbar from './snackbarModel';
import alertDialog from './alertModel';
import home from './homeModel';
import ad from './adModel';
import admin from './adminModel';
import banner from './bannerModel';
import account from './accountModel';
import nav from './navModel';
import auth from './authModel';
import user from './userModel';
import order from './orderModel';
import product from './productModel';
import ingredient from './ingredientModel';
import conversion from './conversionModel';
import menu from './menuModel';
import merchant from './merchantModel';
import packages from './packageModel';
import payment from './paymentModel';
import category from './categoryModel';
import supplier from './supplierModel';
import mpy from './topupModel';
import transaction from './transactionModel';
import subscription from './subscriptionModel';
import schedule from './scheduleModel';
import refund from './refundModel';
import voucher from './voucherModel';

const store = {
    account,
    ad,
    admin,
    alert,
    alertDialog,
    app: appModel,
    auth,
    banner,
    category,
    home,
    ingredient,
    menu,
    conversion,
    mpy,
    merchant,
    nav,
    order,
    packages,
    product,
    refund,
    payment,
    schedule,
    snackbar,
    subscription,
    supplier,
    transaction,
    user,
    voucher,
};

export default store;
